import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.approve.signup');
import { RequestList } from "src/libs/request-list";
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcuser-approve-signup',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.approve.signup/view.scss */
/* src/app/portal.gsdcuser.approve.signup/view.scss: no such file or directory */`],
})
export class PortalGsdcuserApproveSignupComponent implements OnInit {
    public requestList = new RequestList('signup');
    public loadFailed = false;
    public requests: any[] = [];
    public loading: boolean = false;
    public is_pi: boolean = false;
    public is_community_rep: boolean = false;
    public is_manager: boolean = false;
    public community_id: string = '';


    constructor(@Inject( Service) public service: Service) { }

    async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");

        this.community_id = this.service.auth.session.community_id;

        await this.loadApprovalRoles();
        await this.loadRequests();
    }

    public async loadApprovalRoles() {
        const { code, data } = await wiz.call('get_approval_roles');
        if (code === 200) {
            this.is_pi = data.is_pi;
            this.is_community_rep = data.is_community_rep;
            this.is_manager = data.is_manager;
        }
        await this.service.render();
    }

    // 요청 데이터를 로드하는 함수
    public async loadRequests() {
        this.loading = true;
        this.loadFailed = false;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('get_pending_requests');
            if (code !== 200 || !Array.isArray(data)) throw new Error('load');
            this.requests = data;
            this.requestList.setRows(data.filter(request => request.request_type === 'S'));
        } catch (_) {
            this.loadFailed = true;
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async changePage(page: number) {
        this.requestList.changePage(page);
        await this.service.render();
    }

    // 승인 처리 함수
    public processing = false;
    public async approveRequest(request_id: string) { await this.processRequest(request_id, true); }
    public async rejectRequest(request_id: string) { await this.processRequest(request_id, false); }

    private async processRequest(request_id: string, approve: boolean) {
        if (this.processing) return;
        this.processing = true;
        let submitted = false;
        let message = '';
        let succeeded = false;
        try {
            const row = this.requests.find(request => request.id === request_id);
            const managerFinal = approve && row?.manager_final_approval === true;
            const skip = managerFinal && row?.manager_skip_representative === true;
            const confirmation = row?.status === 'D' ? '중단되거나 실패한 가입·그룹 처리를 이어서 진행하시겠습니까?' : skip ? (row?.manager_skip_pi ? '그룹 대표(PI) 승인과 남은 중간 승인 단계를 생략하고 최종 승인하여 계정을 생성하시겠습니까?' : '커뮤니티 대표 승인을 생략하고 최종 승인하여 계정을 생성하시겠습니까?') : '승인하시겠습니까?';
            const confirmed = approve
                ? await this.service.alert.success(confirmation, '취소')
                : await this.service.alert.error('거절하시겠습니까?', '취소');
            if (!confirmed) return;
            submitted = true;
            this.service.loading.show();
            // Reuse the management endpoint for final approval and its retry/audit logic.
            const payload: any = { request_id };
            if (managerFinal) payload.tab = 'signup';
            if (skip) payload.skip_representative = '1';
            const api = managerFinal ? wiz.app('portal.gsdcadmin.request') : wiz;
            const action = managerFinal ? 'approve_request' : (approve ? 'approve_request' : 'reject_request');
            const { code, data } = await api.call(action, payload, { timeout: 135000 });
            succeeded = code === 200;
            message = typeof data === 'string' ? data : data?.message;
            if (!message) message = succeeded
                ? (approve ? '요청이 승인되었습니다.' : '요청이 거절되었습니다.')
                : '요청 처리에 실패했습니다. 목록을 확인한 후 다시 시도해주세요.';
        } catch (_) {
            message = '처리 결과를 확인하지 못했습니다. 목록을 확인한 후 다시 시도해주세요.';
        } finally {
            this.service.loading.hide();
            try {
                if (submitted) await this.loadRequests();
                if (message) {
                    if (succeeded) await this.service.alert.success(message);
                    else await this.service.alert.error(message);
                }
            } finally {
                this.processing = false;
                await this.service.render();
            }
        }
    }
}

export default PortalGsdcuserApproveSignupComponent;